import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from 'primereact/button';
import { API, DataStore, graphqlOperation } from 'aws-amplify';
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { toast } from "react-toastify";
import { graphQLFindRecordById } from "../../helper/commonfunctions";
import { Column } from "primereact/column";
// CheckboxColumn.js
import { Checkbox } from 'primereact/checkbox';

const CheckboxColumn = ({ data,selectedRows,setSelectedRows})=> {
    console.log("test")
	  
    const handleSelectAll = (e) => {
    if (selectedRows.length === data.length) {
        // If all rows are already selected, clear the selection
        setSelectedRows([]);
    } else {
        // If not all rows are selected, select all rows
        const allRowIds = data.map((row) => row.id);
        setSelectedRows(allRowIds);
    }
  };

  const handleCheckboxChange = (e, rowData) => {
	  console.log(rowData.id,"userid")
    const selectedRowId = rowData.id;
    if (selectedRows.includes(selectedRowId)) {
        // If the row is already selected, remove it from the selection
        setSelectedRows(selectedRows.filter((rowId) => rowId !== selectedRowId));
    } else {
        // If the row is not selected, add it to the selection
        setSelectedRows([...selectedRows, selectedRowId]);
    }
  };
	return (
	<>
	
	 
      <Checkbox
        onChange={(e) => handleCheckboxChange(e, data)}
        checked={selectedRows.includes(data.id)}
      />
	  
	<Column
        field={"checkbox"}
        header={<Checkbox onChange={handleSelectAll} checked={selectedRows.length === data.length} />}
        
        body={(row) => (
          <Checkbox
                onChange={(e) => handleCheckboxChange(e,row)}
                checked={selectedRows.includes(row.id)}
            />
        )}
      ></Column>
	  </>
       
    );
};

export default CheckboxColumn;